(function ($) {
  'use strict';

  var initGalleryCarousel = function () {

    //function to toggle dots vs. arrows
    var toggleDots = function (slider) {
      var showThumbsMinWidth = slider.parent().hasClass('js-inside-gallery') ? 420 : 850;
      //show/hide dots vs. thumbnails
      if (slider.parent().width() < showThumbsMinWidth) {
        slider
          .closest('.gallery')
          .find('.gallery__items .slick-dots')
          .show();
        slider
          .find('.slick-arrow')
          .hide();
        slider
          .find('.slick-list')
          .hide();

        // if alternate gallery styling applied, remove it from main slider description
        // and thumbnail slider
        if (slider.closest('.gallery').hasClass('gallery--alternate-thumbs')) {
          slider
            .closest('.gallery')
            .find('.gallery__description')
            .removeClass('gallery__description--alternate-thumbs');
          slider
            .closest('.gallery')
            .find('.gallery__thumbnails-container')
            .removeClass('gallery__thumbnails-container--alternate-thumbs');
        }

        //show image-only slider arrows
        if (slider.closest('.gallery').hasClass('gallery--images-only')) {
          slider
            .closest('.gallery')
            .find('.gallery__items .slick-arrow')
            .show();
        }

      } else {
        slider
          .find('.slick-arrow')
          .show();
        slider
          .find('.slick-list')
          .show();
        slider
          .closest('.gallery')
          .find('.gallery__items .slick-dots')
          .hide();

        // if alternate gallery styling applied, apply it to main slider description and
        // thumbnail slider
        if (slider.closest('.gallery').hasClass('gallery--alternate-thumbs')) {
          slider
            .closest('.gallery')
            .find('.gallery__description')
            .addClass('gallery__description--alternate-thumbs');
          slider
            .closest('.gallery')
            .find('.gallery__thumbnails-container')
            .addClass('gallery__thumbnails-container--alternate-thumbs');
        }

        //hide image-only slider arrows
        if (slider.closest('.gallery').hasClass('gallery--images-only')) {
          slider
            .closest('.gallery')
            .find('.gallery__items .slick-arrow')
            .hide();
        }

      }

      // Reset slider position this is fix a slick bug where it makes the .slick-list
      // unusually wide when its container div is resized
      // Edit 25/07/18: checks for full screen video before resetting slider
      if (!fullScreenOn) {
        slider
          .parent()
          .find('.gallery__thumbnails')
          .slick('slickGoTo', 0);
      }

      //vertically center arrow position for image-only type galleries
      if (slider.closest('.gallery').hasClass('gallery--images-only')) {
        var parentGalleryImageHeight = slider
          .closest('.gallery')
          .find('.slick-active .gallery__item-image')
          .height();
        slider
          .closest('.gallery')
          .find('.gallery__items .slick-arrow')
          .css('top', parentGalleryImageHeight / 2 - 12 + 'px');
      }
    };

    // function to adjust thumbail slider top position on resize based on parent
    // slider contents height where height used as top offset for thumbnail slider's
    // absolute position
    var alternateThumbs = function (slider) {
      if (slider.closest('.gallery').hasClass('gallery--alternate-thumbs')) {
        //absolute position the thumbnail slider under the active slider using css-top
        var slideHeight = slider
          .parent()
          .find('.slick-active .gallery__item-image')
          .eq(0)
          .height();

        if (slideHeight === 0) {
          slideHeight = slider
            .parent()
            .find('.slick-active .gallery__item-responsive-embed')
            .eq(0)
            .height();
        }

        slider
          .parent()
          .find('.gallery__thumbnails-container')
          .css('top', slideHeight);
      }

    };

    //get all galleries
    var gallery = $('.gallery__items');

    //previous slide id state variable
    var galleryPreviousSlide = [];

    //init each gallery
    gallery.each(function () {
      //init only if it has more than one slide
      var slidesNum = $(this)
        .find('.gallery__item')
        .length;

      if (slidesNum > 1) {
        //get parent gallery ID
        var galleryId = $(this).attr('id');

        //get thumbnail gallery
        var thumbnailGallery = '#thumbnail-' + galleryId;

        //check if inverted variant class is not applied
        var galleryClassisInverted = $(this)
          .closest('.gallery')
          .hasClass('gallery--inverse');

        var galleryClassImageType = $(this)
          .closest('.gallery')
          .hasClass('gallery--images-only');
        var arrowsFlag = false;
        var prevArrowMarkup = '';
        var nextArrowMarkup = '';
        var showDotsFlag = true;
        //if image only gallery type, add arrows to the slider arrows
        if (galleryClassImageType) {
          arrowsFlag = true;
          showDotsFlag = false;
        }

        //apply corresponding nav dots class if .gallery is regular/inverse
        var dotsClass = galleryClassisInverted ?
          'slick-dots' :
          'slick-dots slick-dots--colored';

        //initialise sliders
        var slider = $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: arrowsFlag,
          prevArrow: '<button class="btn slick-arrow-btn--image-only slick-prev"><svg xmlns="http://ww' +
            'w.w3.org/2000/svg" width="12" height="19"><path fill="#FFF" fill-rule="evenodd" ' +
            'd="M9.292 0l2.17 2.141-7.123 7.028 7.123 7.027-2.17 2.142L0 9.17z"/></svg></butt' +
            'on>',
          nextArrow: '<button class="btn slick-arrow-btn--image-only slick-next"><svg xmlns="http://ww' +
            'w.w3.org/2000/svg" width="12" height="19"><path fill="#FFF" fill-rule="evenodd" ' +
            'd="M2.17 0L0 2.141l7.122 7.028L0 16.196l2.17 2.142 9.292-9.169z"/></svg></button' +
            '>',
          dots: showDotsFlag,
          dotsClass: dotsClass,
          adaptiveHeight: true,
          asNavFor: thumbnailGallery //link parent gallery with thumbnail gallery
        });

        //initialise thumbnail gallery
        var thumbnailGallerySlider = $(thumbnailGallery).slick({
          //dotsClass:      dotsClass,
          slidesToShow: 5,
          slidesToScroll: 1,
          asNavFor: '#' + galleryId, //link to parent gallery
          dots: false,
          centerMode: true,
          focusOnSelect: true,
          variableWidth: true,
          prevArrow: '<button class="btn btn--chevron btn--chevron-left slick-prev"><svg focusable="fa' +
            'lse" xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D51' +
            '77" fill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></' +
            'svg>Next</button>',
          nextArrow: '<button class="btn btn--chevron btn--chevron slick-next"><svg focusable="false" ' +
            'xmlns="http://www.w3.org/2000/svg" width="10" height="16"><path fill="#7D5177" f' +
            'ill-rule="evenodd" d="M1.893 0L0 1.868 6.214 8 0 14.13 1.893 16 10 8z" /></svg>P' +
            'revious</button>'
        });

        //check browser width to select dots vs. arrows
        toggleDots(thumbnailGallerySlider.parent());

        // check if alternate thumbnails class is applied to .gallery
        // alternateThumbs(thumbnailGallerySlider.parent()); select default active
        // thumbnail slide
        $(thumbnailGallery).slick('slickGoTo', 0);

        //record current slide ID for use as previous slide before slide change
        slider.on('beforeChange', function (event, slick, currentSlide) {
          galleryPreviousSlide[$(this).attr('id')] = currentSlide;
        });

        // show thumbnail slider this is to fix flash of unstyled content
        thumbnailGallerySlider.show();

        //reset embeded media after slide change
        slider.on('afterChange', function (event, slick) {
          //vertical center align arrows for image only sliders on slide change
          if (slider.closest('.gallery').hasClass('gallery--images-only')) {
            var parentGalleryImageHeight = slider
              .find('.slick-active .gallery__item-image')
              .height();
            slider
              .find('.slick-arrow')
              .css('top', (parentGalleryImageHeight / 2 - 12) + 'px');
          }

          //get parent gallery id
          var parentGalleryId = $(this).attr('id');

          alternateThumbs($(this));

          //using parent gallery id, get previous slide id from the state variable
          var previousSlideId = galleryPreviousSlide[parentGalleryId];

          //get embed contents
          var embededContents = $(slick.$slides[previousSlideId]).find('.gallery__item-responsive-embed');

          //if embeded content found
          if (embededContents.length) {
            //create backup of embeded content
            var embedContentsRestore = embededContents;

            //reset embeded content
            embededContents.html(embedContentsRestore.html());
          }
        });
      }
    });

    var resizeTimer;
    var sliders = $('.gallery__thumbnails-container');
    var width = $(window).width(); // Used in toggleDots to check width after resize
    var fullScreenOn = false;

    // show hide carousel arrows/dots on window resize and if alternative thumbnail
    // layout is required
    $(window).on('resize', function () {
      // throttle resize event
      // https://css-tricks.com/snippets/jquery/done-resizing-event/
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        sliders
          .each(function () {
            checkFullScreen();
            toggleDots($(this));
            alternateThumbs($(this));
          });
        width = $(window).width(); // Update width after updates
      }, 100);
    });

    /* set iFrame title attr - ref: UNECCTNM-96 */
    $('.gallery__item-responsive-embed').each(function () {
      var iframeTitle = $(this)
        .parent()
        .find('.gallery__heading')
        .text();
      $(this)
        .find('iframe')
        .attr('title', iframeTitle);
    });

    // Edit 25/07/18: Checks if window is in full screen, currently used for toggleDots function
    function checkFullScreen() {
      var state = document.fullscreen || document.fullscreenElement || document.mozFullScreenElement || document.mozFullScreen || document.webkitCurrentFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
      fullScreenOn = state ? true : false;
    }
  };
  //init gallery carousel
  initGalleryCarousel();
}(jQuery));